import * as T from '../types/index'
const serviceURL = '/services/plugin-attributes-manager'

// attributes endpoints
export const ATTRIBUTES = `${serviceURL}/attribute/`
export const EDIT_ATTRIBUTE = (id: T.IdType) => `${serviceURL}/attribute/${id}`

// derived quantities endpoints
export const DERIVED_QUANTITIES = `${serviceURL}/derived-quantity/`
